import React from 'react';
import Icon from './Icon';

export default class DhabiSadIcon extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="66"
      height="90"
      viewBox="0 0 66 90"
    >
      <defs>
        <path id="prefix__a" d="M0 0L43.8 0 43.8 51 0 51z" />
        <path
          id="prefix__c"
          d="M5.617 23.683c4.653 6.963 5.662 17.932 6.258 18.25 2.17 1.154 7.002.177 6.7-1.19-.122-.557-3.312-14.263-10.625-21.384C.725 12.323 2.894.242 2.15.065L2.122.062c-.942 0-5.165 10.663 3.494 23.621"
        />
        <path
          id="prefix__e"
          d="M1.394 0C.002 0-.419.773.456 1.729l2.16 2.356c.874.953 2.293.954 3.169 0l2.158-2.356C8.818.775 8.4 0 7.006 0H1.394z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FACF58"
          d="M16.926 55.972C3.304 51.109-1.202 37.19.265 35.499c1.297-1.494 16.661-1.855 19.938 12.373.868 3.77 3.048 6.318 3.185 7.587.226 2.099-2.758 1.835-6.462.513"
        />
        <path
          fill="#F4A335"
          d="M12.534 50.371C4.74 47.521 4.8 39.601 4.8 39.601s7.407.421 11.22 8.688c.947 2.053 2.5 2.76 2.577 3.504.13 1.23-3.945-.647-6.063-1.422"
        />
        <path
          fill="#FACF58"
          d="M48.474 55.972c13.622-4.863 18.128-18.782 16.661-20.473-1.297-1.494-16.661-1.855-19.938 12.373-.868 3.77-3.048 6.318-3.185 7.587-.226 2.099 2.758 1.835 6.462.513"
        />
        <path
          fill="#F4A335"
          d="M52.866 50.371c7.792-2.85 7.734-10.77 7.734-10.77s-7.408.421-11.22 8.688c-.947 2.053-2.499 2.76-2.577 3.504-.129 1.23 3.945-.647 6.063-1.422"
        />
        <g transform="translate(10.2 39)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            fill="#F4A335"
            d="M0 22.174C0 5.644 9.805 0 21.9 0c12.095 0 21.9 5.645 21.9 22.174C43.8 38.702 32.403 51 21.9 51 11.398 51 0 38.702 0 22.174"
            mask="url(#prefix__b)"
          />
        </g>
        <path
          fill="#FACF58"
          d="M27.887 81.554c2.357-.874.104-13.797-6.237-20.895-6.341-7.099-5.475-13.26-5.475-13.26S7.752 58.57 13.28 70.245c7.243 15.3 13.535 11.709 14.608 11.31"
        />
        <path
          fill="#F5D577"
          d="M36.313 81.554c-2.358-.874-.105-13.797 6.237-20.895 6.341-7.099 5.475-13.26 5.475-13.26s8.423 11.17 2.896 22.845c-7.243 15.3-13.535 11.709-14.608 11.31"
        />
        <path
          fill="#FACF58"
          d="M32.7 78.006c-6.115-1.938-10.5 2.471-10.5 5.944 0 4.751 4.11 6.02 10.5 6.05 6.39-.03 10.5-1.299 10.5-6.05 0-3.473-4.218-8.25-10.5-5.944"
        />
        <path
          fill="#F4A335"
          d="M43.119 70.386c-2.202 3.318-3.303 5.272-4.357 7.333-2.266-1.471-3.643-2.571-6.155-2.595-2.51.024-3.781 1.057-6.048 2.528-.975-1.994-2.553-5.798-4.463-7.266l-.267.363c1.615 1.243 4.148 8.45 4.148 8.45 2.899-1.141 5.394-.748 6.63-.748 1.237 0 3.732-.393 6.631.749 0 0 2.533-7.208 4.148-8.451 0 0 1.934-3.68-.267-.363"
        />
        <path
          fill="#302720"
          d="M37.873 40.744c.123-.559 3.312-14.263 10.626-21.385 7.225-7.036 5.056-19.117 5.8-19.294.886-.21 5.276 10.534-3.468 23.618-4.653 6.962-5.661 17.932-6.257 18.249-2.17 1.154-7.002.178-6.701-1.188"
        />
        <g transform="translate(9)">
          <mask id="prefix__d" fill="#fff">
            <use xlinkHref="#prefix__c" />
          </mask>
          <path
            fill="#302720"
            d="M5.617 23.683c4.653 6.963 5.662 17.932 6.258 18.25 2.17 1.154 7.002.177 6.7-1.19-.122-.557-3.312-14.263-10.625-21.384C.725 12.323 2.894.242 2.15.065L2.122.062c-.942 0-5.165 10.663 3.494 23.621"
            mask="url(#prefix__d)"
          />
        </g>
        <g>
          <path
            fill="#302720"
            d="M25.2 8.4c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3"
            transform="translate(17.4 57)"
          />
          <path
            fill="#FDFFFF"
            d="M23.032 1.13c-.356.928.865 2.25 2.725 2.951 1.86.702 3.656.517 4.012-.41.354-.93-.867-2.25-2.726-2.952-1.86-.702-3.657-.519-4.011.41"
            transform="translate(17.4 57)"
          />
          <path
            fill="#302720"
            d="M6 8.4c0-1.657-1.343-3-3-3s-3 1.343-3 3 1.343 3 3 3 3-1.343 3-3"
            transform="translate(17.4 57)"
          />
          <path
            fill="#FDFFFF"
            d="M6.873.901c.418.903-.709 2.305-2.516 3.132-1.808.828-3.612.766-4.03-.135-.418-.902.709-2.304 2.516-3.131C4.652-.061 6.455-.001 6.873.9"
            transform="translate(17.4 57)"
          />
          <path
            fill="#302720"
            d="M12.634 29.609L12.32 28.065 18.566 26.792 18.881 28.335z"
            transform="translate(17.4 57)"
          />
        </g>
        <g transform="translate(28.2 77.4)">
          <mask id="prefix__f" fill="#fff">
            <use xlinkHref="#prefix__e" />
          </mask>
          <path
            fill="#EC6E52"
            d="M-3 7.8L11.4 7.8 11.4 -3 -3 -3z"
            mask="url(#prefix__f)"
          />
        </g>
      </g>
    </svg>
  );
}
